export default __webpack_public_path__ + "static/needlefilewithoutdust-738ff6bd458de0488289ab88f8b1ca31.png";